import React from 'react';
import ReactDOM from 'react-dom/client'; // 👈 merk: ny import
import './index.css';
import HttpsRedirect from 'react-https-redirect';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HttpsRedirect>
    <App />
  </HttpsRedirect>
);
